import React from "react";
import {  Container } from "reactstrap";
import success from "../../../images/success.png";

export default function SuccessPayment(props) {
  const { agency } = props;
  return (
    <div className={agency ? "agency-wrapper" : ""}>
      <Container>
        <div className="page-title">
          <h4>Payment </h4>
        </div>

        <div className="payment-success text-center">
          <img src={success} alt="new" />
          <h4>Your Payment is Successful.</h4>
          {/* <p>Please check your email for confirmation.</p> */}
          {/* <div className="text-center">
            <Button
              onClick={props.handleButton}
              className="ln-btn"
              color="primary"
              size="lg"
            >
              {props.buttonLabel || "License List"}
            </Button>
          </div> */}
        </div>
      </Container>
    </div>
  );
}
